import React from "react";
import SeoMeta from "./SeoMeta";
import { PAGE_TITLE_CLASS, PAGE_TITLE_UNDERLINE_CLASS } from "../constants/theme";

function PageHeader({ title, subtitle, titleClassName }) {
    return (
        <div className="text-center mb-12">
            <h1 className={titleClassName ?? `${PAGE_TITLE_CLASS} leading-tight pb-2`}>
                {title}
            </h1>
            <div className={PAGE_TITLE_UNDERLINE_CLASS} />
            {subtitle && <p className="mt-4 text-gray-400 text-lg">{subtitle}</p>}
        </div>
    );
}

export default function PageLayout({ seo, title, subtitle, titleClassName, children }) {
    return (
        <>
            <SeoMeta {...seo} />
            <div className="min-h-screen bg-gray-900 text-white">
                <div className="container mx-auto px-4 py-16">
                    {title && (
                        <PageHeader
                            title={title}
                            subtitle={subtitle}
                            titleClassName={titleClassName}
                        />
                    )}
                    {children}
                </div>
            </div>
        </>
    );
}
